import React, { useEffect, useState } from "react";

const TOSS_SDK_SRC = "https://js.tosspayments.com/v2/standard";
let tossSdkPromise;

function loadTossSdk() {
  if (typeof window === "undefined") {
    return Promise.reject(new Error("결제창은 브라우저에서만 사용할 수 있습니다."));
  }
  if (window.TossPayments) return Promise.resolve(window.TossPayments);
  if (tossSdkPromise) return tossSdkPromise;

  tossSdkPromise = new Promise((resolve, reject) => {
    const existing = document.querySelector(`script[src="${TOSS_SDK_SRC}"]`);
    const script = existing || document.createElement("script");
    const handleLoad = () => {
      if (window.TossPayments) {
        resolve(window.TossPayments);
      } else {
        tossSdkPromise = null;
        reject(new Error("토스페이먼츠 SDK를 초기화하지 못했습니다."));
      }
    };
    const handleError = () => {
      tossSdkPromise = null;
      reject(new Error("토스페이먼츠 SDK를 불러오지 못했습니다."));
    };
    script.addEventListener("load", handleLoad, { once: true });
    script.addEventListener("error", handleError, { once: true });
    if (!existing) {
      script.src = TOSS_SDK_SRC;
      script.async = true;
      document.head.appendChild(script);
    }
  });
  return tossSdkPromise;
}

function checkoutUrl(path, state) {
  const url = new URL(path, window.location.origin);
  url.searchParams.set("checkout", state);
  return url.toString();
}

export default function PaymentWidget({
  clientKey,
  price,
  orderId,
  orderName,
  customerName,
  successPath = "/ko?tab=shop",
  failPath = "/ko?tab=shop",
  onFail,
}) {
  const [sdkReady, setSdkReady] = useState(false);
  const [requesting, setRequesting] = useState(false);

  useEffect(() => {
    let cancelled = false;
    loadTossSdk()
      .then(() => !cancelled && setSdkReady(true))
      .catch((error) => !cancelled && onFail?.(error));
    return () => {
      cancelled = true;
    };
  }, [onFail]);

  const handlePayment = async () => {
    if (!clientKey || !price || !orderId || requesting) return;
    setRequesting(true);
    try {
      const TossPayments = await loadTossSdk();
      const payment = TossPayments(clientKey).payment({ customerKey: orderId });
      await payment.requestPayment({
        method: "CARD",
        amount: { currency: "KRW", value: Number(price) },
        orderId,
        orderName,
        customerName: customerName || "Disparty User",
        successUrl: checkoutUrl(successPath, "success"),
        failUrl: checkoutUrl(failPath, "fail"),
        card: { flowMode: "DEFAULT" },
      });
    } catch (error) {
      onFail?.(error);
      console.error("Payment failed", error);
      setRequesting(false);
    }
  };

  const disabled = !sdkReady || !clientKey || !price || !orderId || requesting;
  return (
    <div className="my-4 rounded-lg border border-[#33363f] bg-[#17181c] p-3">
      <button
        type="button"
        onClick={handlePayment}
        disabled={disabled}
        className="w-full rounded-lg bg-[#5865F2] py-3.5 text-base font-bold text-white transition-colors hover:bg-[#4a56d1] disabled:cursor-not-allowed disabled:bg-gray-700 disabled:text-gray-400"
      >
        {requesting ? "결제창 여는 중..." : `${Number(price || 0).toLocaleString()}원 카드 결제하기`}
      </button>
    </div>
  );
}
